import { RouteLocationRaw, useRouter as useVueRouter } from "vue-router";

function useRouter() {
  const router = useVueRouter();
  const previousUrl = computed(() => {
    return router.options.history.state.back as string;
  });

  const previousRoute = computed(() => {
    return router.resolve({ path: previousUrl.value });
  });

  return {
    ...useVueRouter(),
    previousUrl,
    previousRoute,
    push(to: RouteLocationRaw) {
      let route = to;
      if (typeof route == 'string') {
        route = router.resolve(route);
      }

      if (route.query == undefined) route.query = {};

      if (!("_t" in route.query)) {
        route.query["_t"] = Date.now().toString();
      }

      return router.push(route);
    },
    replace(to: RouteLocationRaw) {
      let route = to;
      if (typeof route == 'string') {
        route = router.resolve(route);
      }

      if (route.query == undefined) route.query = {};

      if (!("_t" in route.query)) {
        route.query["_t"] = Date.now().toString();
      }

      return router.replace(route);
    }
  }
}

export default useRouter;
